/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Results_BreadcrumbInputs */

const en_search_results_breadcrumb = /** @type {(inputs: Search_Results_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Results`)
};

const nl_search_results_breadcrumb = /** @type {(inputs: Search_Results_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoekresultaten`)
};

/**
* | output |
* | --- |
* | "Search Results" |
*
* @param {Search_Results_BreadcrumbInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const search_results_breadcrumb = /** @type {((inputs?: Search_Results_BreadcrumbInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Results_BreadcrumbInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_search_results_breadcrumb(inputs)
	return en_search_results_breadcrumb(inputs)
});